<ng-container>
    <ng-container *ngIf="searchDisplay">
        <!--begin: Search -->
        <!-- <kt-search-dropdown [icon]="'./assets/media/svg/icons/General/Search.svg'" [useSVG]="true"></kt-search-dropdown> -->
        <!--end: Search -->
    </ng-container>

    <ng-container *ngIf="notificationsDisplay"> </ng-container>


    <ng-container>
        <kt-language-selector></kt-language-selector>
    </ng-container>

    <ng-container *ngIf="userDisplay">
        <ng-container *ngIf="userLayout === 'dropdown'">
            <kt-user-profile></kt-user-profile>
        </ng-container>
        <ng-container *ngIf="openUser">
            <kt-user-profile-side [userName]="userName" [name]="givenName"></kt-user-profile-side>
        </ng-container>
    </ng-container>
</ng-container>
<!-- end:: Header Topbar -->